var _style, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTips(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#C40005;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 24,
    height: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.3,20.8h4.1c0,1.1-0.9,2-2,2S6.3,21.9,6.3,20.8z M4.2,19.8h8.2v-2H4.2V19.8z M16,10.1c0,3.9-2.7,6-3.9,6.6 H4.5c-1.1-0.7-3.9-2.7-3.9-6.6c0-4.2,3.4-7.7,7.7-7.7S16,5.8,16,10.1z M21,7.9l-1.4,0.6L21,9.2l0.6,1.4l0.6-1.4l1.4-0.6l-1.4-0.6 l-0.6-1.4L21,7.9z M18.5,6.5l1-2.1l2.1-1l-2.1-1l-1-2.1l-1,2.1l-2.1,1l2.1,1L18.5,6.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTips);
export default __webpack_public_path__ + "static/media/tips.f16256ff3b4521c525de932b724d3dca.svg";
export { ForwardRef as ReactComponent };